<template>
  <div class="timeRange">
    <div class="time_range">
      <div class="time_select" v-show="timeType==='2'">
        <div class="time"  @click="active(0)" :class="activeSelect ===0 ? 'active':''">{{ startTimeSelected }}
        </div>
        <div class="divide" v-if="timeType==='2'">-</div>
        <div class="time" v-if="timeType==='2'" @click="active(1)" :class="activeSelect ===1 ? 'active':''">
          {{ endTimeSelected }}
        </div>
      </div>

      <div class="time_show">
        <div class="time_mark" :style="{'top':timeType=='1' ? '166px':'205px'}"></div>
        <div class="time_item_hour" @scroll="divscrollHour($event)" v-if="showHour">
          <div class="blank" v-for="size in 3"></div>
          <div class="item" v-for="count in 24">
            {{ count - 1 }}时
          </div>
          <div class="blank" v-for="size in 3"></div>
        </div>
        <div class="time_item_min" @scroll="divscrollMin($event)" v-if="showMin">
          <div class="blank" v-for="size in 3"></div>
          <div class="item" v-for="count in 60">
            {{ count - 1 }}分
          </div>
          <div class="blank" v-for="size in 3"></div>
        </div>
        <div class="time_item_sec" @scroll="divscrollSec($event)" v-if="showSec">
          <div class="blank" v-for="size in 3"></div>
          <div class="item" v-for="count in 60">
            {{ count - 1 }}秒
          </div>
          <div class="blank" v-for="size in 3"></div>
        </div>
      </div>

    </div>

    <div class="time_button">
      <div class="clear" @click="clearInput">清空并退出</div>
      <div class="sure" @click="sureInput">确定</div>
    </div>
  </div>

</template>
<script>

export default {
  props: {
    cusParam_timeData: Array,
    cusParam_timeMask: String,
    cusParam_timeType: String,
  },
  computed: {},
  watch: {
    cusParam_timeType: function (timeType) {
      this.timeType = timeType
    },
    cusParam_timeData: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(timeData) {
        if (timeData.length > 0) {
          this.startTimeSelected = timeData[0];
        }
        if (timeData.length > 1 && this.timeType === '2') {
          this.endTimeSelected = timeData[1];
        }
      }
    },
    cusParam_timeMask: function (timeMask) {
      if (RegExp(/HH/i).test(timeMask)) {
        this.showHour = true;
      }
      if (RegExp(/mm/i).test(timeMask)) {
        this.showMin = true;
      }
      if (RegExp(/ss/i).test(timeMask)) {
        this.showSec = true;
      }
      this.initTime();
      this.$nextTick(() => {
        this.initTimeSelect();
      })
    },
  },
  data() {
    return {
      startTimeSelected: "",
      endTimeSelected: "",
      startHour: "",
      startMin: "",
      startSec: "",
      endHour: "",
      endMin: "",
      endSec: "",
      showHour: false,
      showMin: false,
      showSec: false,
      activeSelect: 0,
      timeType: ""
    }
  },
  mounted() {
  },
  methods: {
    divscrollHour(event) { //监听滚动事件
      const currentTop = event.target.scrollTop //首先记录当前出发时的位置
      setTimeout(() => {
        if (event.target.scrollTop === currentTop) { //如果300毫秒后仍相同 就认为停止滚动了
          //在此调用自动校准的方法
          let el = event.target
          let hours = Math.round(el.scrollTop / 36)
          if (this.activeSelect === 0) {
            this.startHour = this.fomartTime(hours)
          } else {
            this.endHour = this.fomartTime(hours)
          }
          this.autoFix(el, Math.round(el.scrollTop / 36) * 36, el.scrollTop)
          this.setSelectTime()
          console.log(hours)
        }
      }, 300)
    },
    divscrollMin(event) { //监听滚动事件
      const currentTop = event.target.scrollTop //首先记录当前出发时的位置
      setTimeout(() => {
        if (event.target.scrollTop === currentTop) { //如果300毫秒后仍相同 就认为停止滚动了
          //在此调用自动校准的方法
          let el = event.target
          let minutes = Math.round(el.scrollTop / 36)
          if (this.activeSelect === 0) {
            this.startMin = this.fomartTime(minutes)
          } else {
            this.endMin = this.fomartTime(minutes)
          }
          this.setSelectTime()
          this.autoFix(el, Math.round(el.scrollTop / 36) * 36, el.scrollTop)
        }
      }, 300)
    },
    divscrollSec(event) { //监听滚动事件
      const currentTop = event.target.scrollTop //首先记录当前出发时的位置
      setTimeout(() => {
        if (event.target.scrollTop === currentTop) { //如果300毫秒后仍相同 就认为停止滚动了
          //在此调用自动校准的方法
          let el = event.target
          let seconds = Math.round(el.scrollTop / 36)
          if (this.activeSelect === 0) {
            this.startSec = this.fomartTime(seconds)
          } else {
            this.endSec = this.fomartTime(seconds)
          }
          this.autoFix(el, Math.round(el.scrollTop / 36) * 36, el.scrollTop)
          this.setSelectTime()
        }
      }, 300)
    },
    setSelectTime() {
      if (this.activeSelect === 0) {
        this.startTimeSelected = (this.showHour ? this.startHour + ":" : "") + (this.showMin ? this.startMin : "") + (this.showSec ? ":" + this.startSec : "");
      } else {
        this.endTimeSelected = (this.showHour ? this.endHour + ":" : "") + (this.showMin ? this.endMin : "") + (this.showSec ? ":" + this.endSec : "");
      }

    },
    active(select) {
      //当鼠标点击后，data中activeNum的值则为点击的li的下标
      this.activeSelect = select
      this.initTimeSelect()
    },
    autoFix(e, top, beginTop) {
      this.timer = setInterval(() => {
        if (e.scrollTop > top) { // 向下校正
          if (beginTop < e.scrollTop) window.clearInterval(this.timer) // 防止矫正位置时再次滚动导致回滚距离变大
          --e.scrollTop
          if (e.scrollTop < top) { // 防止top为小数时出现永远无法e.target.scrollTop = top导致一直运行的问题
            e.scrollTop += 0.5
            window.clearInterval(this.timer)
          }
        } else if (e.scrollTop < top) { // 向上校正
          if (beginTop > e.scrollTop) window.clearInterval(this.timer)
          ++e.scrollTop
          if (e.scrollTop > top) {
            e.scrollTop -= 0.5
            window.clearInterval(this.timer)
          }
        } else {
          window.clearInterval(this.timer)
        }
      }, 1000 / 60)
    },
    initTime() {
      this.startTimeSelected = this.startTimeSelected ? this.getInitTime(0) : this.getCurrentTime(0);
      this.endTimeSelected = this.endTimeSelected ? this.getInitTime(1) : this.getCurrentTime(1);
    },
    getInitTime(type) {
      if (type === 0) {
        var timeArr = this.startTimeSelected.split(":");
        if (this.showHour) {
          this.startHour = timeArr[0];
          if (this.showMin) {
            this.startMin = timeArr[1];
            if (this.showSec) {
              this.startSec = timeArr[2];
            }
          }
        } else {
          if (this.showMin) {
            this.startMin = timeArr[0];
            if (this.showSec) {
              this.startSec = timeArr[1];
            }
          }
        }
        return this.startTimeSelected
      } else {
        var timeArr = this.endTimeSelected.split(":");
        if (this.showHour) {
          this.endHour = timeArr[0];
          if (this.showMin) {
            this.endMin = timeArr[1];
            if (this.showSec) {
              this.endSec = timeArr[2];
            }
          }
        } else {
          if (this.showMin) {
            this.endMin = timeArr[0];
            if (this.showSec) {
              this.endSec = timeArr[1];
            }
          }
        }
        return this.endTimeSelected
      }
    },
    initTimeSelect() {
      if (this.activeSelect === 0) {
        if (this.showHour) {
          document.querySelector('.time_item_hour').scrollTo({top: this.startHour * 36})
        }

        if (this.showMin) {
          clearTimeout(this.minTimer);  //清除延迟执行
          this.minTimer = setTimeout(() => {   //设置延迟执行
            document.querySelector('.time_item_min').scrollTo({top: this.startMin * 36})
          }, 100);
        }
        if (this.showSec) {
          clearTimeout(this.secTimer);  //清除延迟执行
          this.secTimer = setTimeout(() => {   //设置延迟执行
            document.querySelector('.time_item_sec').scrollTo({top: this.startSec * 36})
          }, 200);
        }

      } else {
        if (this.showHour) {
          document.querySelector('.time_item_hour').scrollTo({top: this.endHour * 36})
        }
        if (this.showMin) {
          clearTimeout(this.minTimer);  //清除延迟执行
          this.minTimer = setTimeout(() => {   //设置延迟执行
            document.querySelector('.time_item_min').scrollTo({top: this.endMin * 36})
          }, 300);
        }
        if (this.showSec) {
          clearTimeout(this.secTimer);  //清除延迟执行
          this.secTimer = setTimeout(() => {   //设置延迟执行
            document.querySelector('.time_item_sec').scrollTo({top: this.endSec * 36})
          }, 400);
        }

      }

    },
    getCurrentTime(type) {
      var date = new Date();
      var sign = ":";
      var hours = this.fomartTime(date.getHours()); // 时
      var minutes = this.fomartTime(date.getMinutes()); // 分
      var seconds = this.fomartTime(date.getSeconds()); //秒
      if (type === 0) {
        this.startHour = hours
        this.startMin = minutes
        this.startSec = seconds
      } else {
        this.endHour = hours
        this.endMin = minutes
        this.endSec = seconds
      }
      var currentdate = (this.showHour ? hours + sign : "") + (this.showMin ? minutes : "") + (this.showSec ? sign + seconds : "");
      return currentdate;
    },
    clearInput() {
      this.invoke("timeRange_clear");
    },
    sureInput() {
      let select = [];
      select.push(this.startTimeSelected);
      if(this.timeType==='2'){
        select.push(this.endTimeSelected);
      }
      this.invoke("timeRange_select", select);
    },
    fomartTime(time) {
      if (time >= 0 && time <= 9) {
        time = "0" + time;
      }
      return time;
    }
  }
}
</script>
<style lang="less">
.timeRange {
  display: flex;
  flex-direction: column;

  .time_range {
    display: flex;
    flex-direction: column;
    padding: 12px;
    border-bottom: 1px solid #E5E5E5;

    .time_select {
      display: flex;
      flex-direction: row;
      height: 28px;
      margin-bottom: 12px;
      justify-content: center;

      .active {
        background: #F2F2F2;
        border: 0.5px solid rgba(39, 111, 245, 1);
        border-radius: 4px;
      }

      .time {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #F2F2F2;
        border-radius: 4px;
        width: 50%;
        height: 28px;
        font-size: 12px;
        color: #212121;
        letter-spacing: 0;
        text-align: center;
        line-height: 16px;
        font-weight: 400;
      }

      .divide {
        margin-right: 1px;
        margin-left: 1px;
      }
    }

    .time_show {
      display: flex;
      flex-direction: row;
      height: 255px;

      .time_mark {
        height: 36px;
        position: absolute;
        left: 0;
        width: 100%;
        background-color: #f2f2f2;
      }

      .time_item_hour, .time_item_sec, .time_item_min {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 1;
        overflow-y: auto;
        margin-bottom: 12px;

        .blank {
          min-height: 36px;
        }

        .item {
          min-height: 36px;
          padding: 8px 4px;
          z-index: 1;
        }
      }
    }
  }

  .time_button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    height: 50px;

    .clear {
      margin: 14px 0px 14px 12px;
      font-size: 14px;
      color: #276FF5;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
    }

    .sure {
      margin: 6px 12px 6px 0px;
      background: #276FF5;
      height: 36px;
      width: 88px;
      border-radius: 4px;
      font-size: 14px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      font-weight: 500;
      align-items: center;
      display: flex;
      justify-content: center;
    }

  }
}
</style>